import React from 'react';
import Label from '../Label/Label';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './MultiSelect.module.scss';
import { default as ReactSelect, MultiValue, GroupBase } from 'react-select';
import useTranslation from '../../../Hooks/useTranslation';
import { SelectValue } from '../Select/Select';
import useSelectOptions from '../../../Modules/Base/Hooks/useSelectOptions';

interface IMultiSelect {
	onChange?: any;
	onChangeExtra?: any;
	placeholder?: string;
	value?: SelectValue[];
	label?: string;
	firstUpper?: boolean;
	options: SelectValue[];
	isSearchable?: boolean;
	closeMenuOnSelect?: boolean;
	noOptionsMessage?: string;
	portal?: boolean;
	translateOptions?: boolean;
}

export default function MultiSelect(props: IMultiSelect) {
	const {
		label,
		onChange,
		onChangeExtra,
		closeMenuOnSelect = false,
		placeholder = 'base.shared.pick',
		value,
		firstUpper = false,
		options,
		isSearchable = false,
		portal,
		translateOptions,
	} = props;

	const { t } = useTranslation();

	const { translatedOptions } = useSelectOptions(options, translateOptions);

	const handleOnChange = (newValue: MultiValue<SelectValue>) => {
		onChange?.(newValue);
		onChangeExtra?.(newValue);
	};

	const noOptionsMessage = props.noOptionsMessage
		? t(props.noOptionsMessage)
		: t('base.noOptions');

	const customStyles = {};

	return (
		<div className={styles.wrapper}>
			{label && <Label tx={label} firstUpper={firstUpper} />}
			<ReactSelect<SelectValue, true, GroupBase<SelectValue>>
				noOptionsMessage={() => noOptionsMessage}
				options={translatedOptions}
				classNamePrefix={'reactSelect'}
				styles={customStyles}
				placeholder={t(placeholder)}
				onChange={handleOnChange}
				isMulti={true}
				isSearchable={isSearchable}
				value={value ?? []}
				closeMenuOnSelect={closeMenuOnSelect}
				menuPosition='fixed'
				menuPortalTarget={portal ? document.body : undefined}
			/>
		</div>
	);
}
